<template>
    <div class="ayuda_admin">
        <v-layout justify-center>
            <v-flex>
                <v-card>
                    <v-card-actions class="justify-center">
                        <v-btn
                                @click="$refs.myPdfComponent.print()"
                                color="primary"
                        >
                            <v-icon>
                                print
                            </v-icon>
                            Imprimir
                        </v-btn>
                        <pdf
                                ref="myPdfComponent"
                                style="display: inline-block; width: 0%"
                                :src="src">
                        </pdf>
                    </v-card-actions>
                    <v-divider/>
                    <v-card-text>
                        <pdf
                                v-for="i in numPages"
                                :key="i"
                                :src="src"
                                :page="i"
                                style="display: inline-block; width: 100%"
                        ></pdf>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import pdf from 'vue-pdf'
    import store from "@/store"

    export default {
        name: "ayuda_admin",
        components:{
          pdf
        },
        data () {
            return {
                pdfLink : '',
                src: '',
                numPages: undefined,
                profileData: {},
            }
        },
        created () {
          this.getProfileData()
        },
        methods:{
            elegir_manual(){
                console.log('Role = ', this.profileData.roll)
                let link
                switch (this.profileData.roll) {
                    case 1: // Empleado
                        link = pdf.createLoadingTask('https://intrare-empresa-test.s3.us-east-2.amazonaws.com/manuales/ManualEmpleado21.pdf')
                    break;
                    case 2: // Vigilante
                        link = pdf.createLoadingTask('https://intrare-empresa-test.s3.us-east-2.amazonaws.com/manuales/ManualVigilante.pdf')
                    break;
                    case 4: // Administrador Parque Industrial
                        link = pdf.createLoadingTask('https://intrare-empresa-test.s3.us-east-2.amazonaws.com/manuales/Manual+Usuario+++Administrador+de+Parque+Industrial.pdf')
                    break;
                    case 5: // Administrador
                        link = pdf.createLoadingTask('https://intrare-empresa-test.s3.us-east-2.amazonaws.com/manuales/ManualAdministrador21.pdf')
                    break;
                }
                return link
            },
            getProfileData () {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/auth/me',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(response => {
                        this.profileData = response.data
                        this.src = this.elegir_manual()
                        this.src.promise.then(pdf => {
                          this.numPages = pdf.numPages
                        })
                        console.log(this.profileData)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
        }
    }
</script>

<style scoped>

</style>
